<template>
  <div class="flex flex-row flex-wrap">
    <span class="btn btn-primary m1"
      v-show="vshow(page)"
      v-for="page in $dados.pages" :key="page.url"
      @click="goto(page)">
      {{page.title}}
    </span>
  </div>
</template>

<script>
var componentData = {
}

export default {
  data: function () {
    return componentData
  },
  props: ['idbloco'],
  methods: {
    vshow: function (page) {
      var name = this.$route.name.split('-')[0]
      if (page.name === name) {
        return false
      }
      return true
    },
    goto: function (page) {
      var params = this.$route.params
      if (this.idbloco) {
        params.idbloco = this.idbloco
      }
      var route = {
        name: page.name,
        params: params
      }
      this.$router.push(route)
    }
  }
}
</script>
